// ポップアップ削除の処理を汎用的な関数として定義
function setupBanner(bannerId, closeButtonSelector, localStorageKey) {
  const banner = document.getElementById(bannerId);
  const closeButton = document.querySelector(closeButtonSelector); // セレクターで指定
  const transitionDuration = 300;
  const fadeInDelay = 10;

  let hideTimeoutId = null;

  // バナーが存在しない場合は処理を終了
  if (!banner) {
    console.warn(`Banner element with ID '${bannerId}' not found.`);
    return;
  }

  // ページ読み込み時にLocalStorageをチェック
  // 'true' でない場合にのみ表示処理の準備をする（最初は 'hidden' が付与されている）
  if (localStorage.getItem(localStorageKey) === "true") {
    banner.classList.add("hidden");
  } else {
    // スクロールで表示するために、最初はhiddenにしておく
    banner.classList.add("hidden");
  }

  // クローズボタンとバナーが存在する場合のみイベントリスナーを設定
  if (closeButton) {
    closeButton.addEventListener("click", function () {
      if (hideTimeoutId) {
        clearTimeout(hideTimeoutId);
        hideTimeoutId = null;
      }

      banner.classList.remove("is-visible");

      hideTimeoutId = setTimeout(() => {
        banner.classList.add("hidden");
        hideTimeoutId = null;
      }, transitionDuration);

      localStorage.setItem(localStorageKey, "true");
    });
  }

  // スクロールイベントリスナーを追加（特定のバナーに対して適用）
  window.addEventListener("scroll", function () {
    if (localStorage.getItem(localStorageKey) === "true") {
      return;
    }

    const scrollY = window.scrollY;
    const documentHeight = document.documentElement.scrollHeight;
    const windowHeight = window.innerHeight;
    const distanceFromBottom = documentHeight - (scrollY + windowHeight);

    // 表示条件: 100pxスクロールし、かつ、フッターから600px以上離れている
    const shouldShow = scrollY > 100 && distanceFromBottom >= 600;

    if (shouldShow) {
      // 既存の非表示タイムアウトがあればクリア（表示に切り替わるため）
      if (hideTimeoutId) {
        clearTimeout(hideTimeoutId);
        hideTimeoutId = null;
      }

      // hiddenクラスが付与されている場合のみフェードイン処理を開始
      if (banner.classList.contains("hidden")) {
        banner.classList.remove("hidden");

        setTimeout(() => {
          banner.classList.add("is-visible");
        }, fadeInDelay);
      } else if (!banner.classList.contains("is-visible")) {
        banner.classList.add("is-visible");
      }
    } else {
      // 非表示条件
      if (banner.classList.contains("is-visible")) {
        if (hideTimeoutId) {
          clearTimeout(hideTimeoutId);
          hideTimeoutId = null;
        }

        banner.classList.remove("is-visible");

        hideTimeoutId = setTimeout(() => {
          banner.classList.add("hidden");
          hideTimeoutId = null;
        }, transitionDuration);
      }
    }
  });
}

// DOMContentLoaded イベント内で、各バナーに対してセットアップ関数を呼び出す
document.addEventListener("DOMContentLoaded", function () {
  // myBanner のセットアップ
  setupBanner("myBanner", "#myBanner .close-banner-1", "hasBannerBeenClosed1");

  // myBanner2 のセットアップ
  setupBanner(
    "myBanner2",
    "#myBanner2 .close-banner-2",
    "hasBannerBeenClosed2"
  );
});

//フェードイン
// document.addEventListener("DOMContentLoaded", () => {
//   const allItems = document.querySelectorAll(".item");

//   const individualItemDelay = 700;
//   const totalAnimationStartDelay = 500;
//   const breakpoint = 768;

//   let currentOrder;

//   // 画面幅に基づいてフェードイン順を決定
//   if (window.innerWidth <= breakpoint) {
//     currentOrder = [
//       document.querySelector(".item:nth-child(1)"),
//       document.querySelector(".item:nth-child(2)"),
//       document.querySelector(".item:nth-child(3)"),
//     ];
//   } else {
//     currentOrder = [
//       document.querySelector(".item:nth-child(2)"),
//       document.querySelector(".item:nth-child(1)"),
//       document.querySelector(".item:nth-child(3)"),
//     ];
//   }

//   // アニメーション全体の開始遅延
//   setTimeout(() => {
//     currentOrder.forEach((item, index) => {
//       if (item) {
//         setTimeout(() => {
//           item.classList.add("fade-in");
//         }, individualItemDelay * index);
//       }
//     });
//   }, totalAnimationStartDelay);
// });

//マッチハイト
$(function () {
  $(".p-product-list li h3").matchHeight();
  $(".p-product-list li .capacity").matchHeight();
  $(".p-product-list li .price").matchHeight();
});

// aboutスライダー
document.addEventListener("DOMContentLoaded", function () {
  const flowSpeed = 4000;

  const mySwiper = new Swiper(".about-slider", {
    loop: true,
    slidesPerView: "auto",
    spaceBetween: 20,

    speed: flowSpeed,
    allowTouchMove: false,
    autoplay: {
      delay: 0,
      disableOnInteraction: false,
    },
    pauseOnMouseEnter: true,
  });
});

// topスライダー
document.addEventListener("DOMContentLoaded", function () {
  const swiper = new Swiper(".top-slider", {
    slidesPerView: "auto",
    centeredSlides: true,
    loop: true,
    speed: 1000,
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
    breakpoints: {
      0: {
        spaceBetween: 10,
      },
      769: {
        spaceBetween: 50,
      },
    },
  });
});
